import React, {PropTypes} from "react";
import RecruiterForm from "../components/RecruiterForm";

class RecruiterAdd extends React.Component {

  constructor() {
    super();
    this.state = {initialValues: {}}
  }

  componentDidMount() {
    this.props.changeBanner("OnBOARDING - ADD NEW")

  }

  componentWillReceiveProps(props) {


  }

  render() {
    return (
      <div>
        <RecruiterForm
          recruiter={this.props.recruiter}
          params={this.props.params}
          submitNew={this.props.submitNew}
          submitEdit={this.props.submitEdit}
          constants={this.props.constants}
          activeEmployees={this.props.activeEmployees}
        />
      </div>
    );
  }
}

RecruiterAdd.propTypes = {};

export default RecruiterAdd;





/** WEBPACK FOOTER **
 ** ./src/feature/onboarding/containers/RecruiterAdd.js
 **/